import {
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Avatar,
    Divider,
    Chip
} from '@mui/material'

import PersonIcon from '@mui/icons-material/Person';
import StorefrontIcon from '@mui/icons-material/Storefront';
import BadgeIcon from '@mui/icons-material/Badge';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';


const ItemcostInfo = ({current}) => {


    const listStyles = {
        color: '#000',
        fontSize: '24px',
        fontFamily: 'sans-serif'
      }


    return(
        <>
        <hr/>
            <List className='contactInfocard'>
            <ListItem >
                    <ListItemAvatar>
                        <Avatar><StorefrontIcon/></Avatar>
                    </ListItemAvatar>
                    


                 <ListItemText style={listStyles} primary="ITEM ID:" secondary={current.onlineId} />
                </ListItem>

                <Divider variant='inset' component="li"/>
            
                <ListItem >
                    <ListItemAvatar>
                        <Avatar><StorefrontIcon/></Avatar>
                    </ListItemAvatar>
                    

                 <ListItemText style={listStyles} primary="STORE ID:" secondary={current.shopId} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PersonIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="OWNER ID" secondary={current.userId} />
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><BadgeIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="LANGUAGE ID " secondary={current.languageType} />
                </ListItem>
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactPhoneIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="UNIT" secondary={current.unit} />
                </ListItem>
                
                <Divider variant='inset' component="li"/>

                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactPhoneIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="MRP" secondary={current.mrp} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                
                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><ContactPhoneIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="PRICE" secondary={current.price} />
                </ListItem>

                <Divider variant='inset' component="li"/>
                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PauseCircleOutlineIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="ONLINE ITEM STATUS:" secondary={current.finalStatus} />
                </ListItem>
                <Divider variant='inset' component="li"/>

                <ListItem>
                    <ListItemAvatar>
                        <Avatar><PauseCircleOutlineIcon/></Avatar>
                    </ListItemAvatar>
                    <ListItemText style={listStyles} primary="ITEM CATEGORY STATUS:" secondary={current.itemStatus} />
                </ListItem>
               
                
                
            


               

               
            </List>
           

        </>
    )
}

export default ItemcostInfo